import { InputLabel, TextField } from '@mui/material';
import React, { ChangeEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';

type MailFormProps = {
  index?: number | string,
  onChangeValue?: ChangeEventHandler,
  mail?: string
};
/* eslint-disable i18next/no-literal-string */
const MailForm: React.FC<MailFormProps> = ({
  index = '',
  onChangeValue = (() => { }),
  mail = ''
}) => {
  const { t } = useTranslation();
  const [stateMail, setMail] = useState(mail);
  React.useEffect(() => {
    setMail(mail);
  }, [mail]);

  return (
    <>
     <InputLabel  style={{ marginTop: 10 }}>{t('MAIL')}</InputLabel>
          <TextField
          style={{ marginBottom: 10 }}
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            required
            size="small"
            fullWidth
            id={`${index}`}
            defaultValue={stateMail}
            onChange={(event: any) => onChangeValue(event)}
          />
    </>
  );
};

export default MailForm;
